export const RETIREMENT_ACCOUNT_SUFFIX = '_Retirement';

export const ORDER_SIDE = {
  Buy: 0,
  Sell: 1,
};
